import { render, staticRenderFns } from "./SysMessageList.vue?vue&type=template&id=7f8f12ab&scoped=true"
import script from "./SysMessageList.vue?vue&type=script&lang=js"
export * from "./SysMessageList.vue?vue&type=script&lang=js"
import style0 from "./SysMessageList.vue?vue&type=style&index=0&id=7f8f12ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8f12ab",
  null
  
)

export default component.exports